import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Button,
  Chip,
  Tooltip,
  Spinner,
} from "@heroui/react";
import { Eye, PencilSimple, Trash, EnvelopeSimple } from "@phosphor-icons/react";
import { EmailTemplate } from "./types";

interface TemplatesTableProps {
  templates: EmailTemplate[];
  isLoading: boolean;
  onPreview: (template: EmailTemplate) => void;
  onEdit: (template: EmailTemplate) => void;
  onDelete: (template: EmailTemplate) => void;
}

export const TemplatesTable: React.FC<TemplatesTableProps> = ({
  templates,
  isLoading,
  onPreview,
  onEdit,
  onDelete
}) => {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-8">
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <Table aria-label="Mail templates table" className="min-w-full">
      <TableHeader>
        <TableColumn>ONDERWERP</TableColumn>
        <TableColumn>TYPE</TableColumn>
        <TableColumn>LABEL</TableColumn>
        <TableColumn>LAATST GEWIJZIGD</TableColumn>
        <TableColumn>ACTIES</TableColumn>
      </TableHeader>
      <TableBody emptyContent="Geen e-mail sjablonen gevonden">
        {templates.map((template) => (
          <TableRow key={template.id}>
            <TableCell>
              <div className="flex items-center gap-2">
                <EnvelopeSimple size={16} className="text-neutral-secondary-mid" />
                <span className="font-medium">{template.subject}</span>
              </div>
            </TableCell>
            <TableCell>
              <Chip
                size="sm"
                className="bg-blue-100 text-blue-800"
                variant="flat"
              >
                {template.templateType}
              </Chip>
            </TableCell>
            <TableCell>
              <Chip
                size="sm"
                className="bg-blue-100 text-blue-800"
                variant="flat"
              >
                {template.label}
              </Chip>
            </TableCell>
            <TableCell>
              <span className="text-sm text-neutral-secondary-mid">
                {template.updatedAt ? new Date(template.updatedAt).toLocaleDateString('nl-BE') : '-'}
              </span>
            </TableCell>
            <TableCell>
              <div className="flex items-center gap-2">
                <Tooltip content="Voorbeeld bekijken">
                  <Button
                    isIconOnly
                    size="sm"
                    variant="light"
                    className="text-neutral-secondary-mid hover:text-moss-primary"
                    onPress={() => onPreview(template)}
                  >
                    <Eye size={16} />
                  </Button>
                </Tooltip>
                <Tooltip content="Bewerken">
                  <Button
                    isIconOnly
                    size="sm"
                    variant="light"
                    className="text-neutral-secondary-mid hover:text-moss-primary"
                    onPress={() => onEdit(template)}
                  >
                    <PencilSimple size={16} />
                  </Button>
                </Tooltip>
                <Tooltip content="Verwijderen">
                  <Button
                    isIconOnly
                    size="sm"
                    variant="light"
                    className="text-neutral-secondary-mid hover:text-danger"
                    onPress={() => onDelete(template)}
                  >
                    <Trash size={16} />
                  </Button>
                </Tooltip>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}; 